/**
 * NotesTab — free-form crm_notes textarea.
 */
import { Loader2 } from "lucide-react";

export default function NotesTab({ notes, setNotes, savingNotes, saveNotes, t }) {
  return (
    <div>
      <textarea
        data-testid="ldd-notes-textarea"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={10}
        placeholder={t("ldd.notes_placeholder")}
        className="al-input w-full text-[12.5px] resize-none"
      />
      <button
        type="button"
        data-testid="ldd-notes-save"
        onClick={saveNotes}
        disabled={savingNotes}
        className="mt-2 h-9 px-4 rounded-lg bg-[#3B82F6] text-white text-[12.5px] font-semibold hover:bg-[#2563EB] disabled:opacity-50 inline-flex items-center gap-1.5"
      >
        {savingNotes ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null}
        {t("ldd.notes_save")}
      </button>
    </div>
  );
}
